import type { IErrorType } from '../../constants/types';

export const types = {
    FETCH_CONNECTIONS: 'adhub/FETCH_CONNECTIONS',
    FETCH_CONNECTIONS_SUCCESS: 'adhub/FETCH_CONNECTIONS_SUCCESS',
    FETCH_CONNECTIONS_FAIL: 'adhub/FETCH_CONNECTIONS_FAIL',

    FETCH_META_OAUTH_URL: 'adhub/FETCH_META_OAUTH_URL',
    FETCH_META_OAUTH_URL_SUCCESS: 'adhub/FETCH_META_OAUTH_URL_SUCCESS',
    FETCH_META_OAUTH_URL_FAIL: 'adhub/FETCH_META_OAUTH_URL_FAIL',

    EXCHANGE_META_OAUTH: 'adhub/EXCHANGE_META_OAUTH',
    EXCHANGE_META_OAUTH_SUCCESS: 'adhub/EXCHANGE_META_OAUTH_SUCCESS',
    EXCHANGE_META_OAUTH_FAIL: 'adhub/EXCHANGE_META_OAUTH_FAIL',

    DISCONNECT_PLATFORM: 'adhub/DISCONNECT_PLATFORM',
    DISCONNECT_PLATFORM_SUCCESS: 'adhub/DISCONNECT_PLATFORM_SUCCESS',
    DISCONNECT_PLATFORM_FAIL: 'adhub/DISCONNECT_PLATFORM_FAIL',
} as const;

export interface IAdHubState {
    connections: any | null;
    fetchingConnections: boolean;
    connecting: boolean;
    disconnecting: boolean;
    error: IErrorType | null;
}

export type IFetchAdHubMetaOAuthUrlPayload = { brandId: string; redirectUri: string };

export type IExchangeAdHubMetaOAuthPayload = {
    brandId: string;
    body: import('../../types/global/adhubConnections.types').IAdHubOAuthExchangeBody;
};

export type IDisconnectAdHubPlatformPayload = { brandId: string; platform: string };
